import type { SchemaItem, SchemaSection } from '@rossum/api-client/schemas';

type SchemaNode = SchemaSection | SchemaItem;

const childrenOf = (node: SchemaNode): SchemaNode[] => {
  if (!('children' in node)) return [];
  return Array.isArray(node.children) ? node.children : [node.children];
};

// A node is hidden when it or any ancestor is — hiding a section or a table hides
// everything inside it on the validation screen.
const collectHidden = (
  nodes: SchemaNode[],
  ancestorHidden: boolean
): string[] =>
  nodes.flatMap(node => {
    const hidden = ancestorHidden || node.hidden === true;
    return [
      ...(hidden ? [node.id] : []),
      ...collectHidden(childrenOf(node), hidden),
    ];
  });

export const toHiddenFieldIds = (
  content: SchemaSection[]
): ReadonlySet<string> => new Set(collectHidden(content, false));
